/*
 * $Id:: routes.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import AccountVerificationPage from '../pages/AuthenticatedPage/AccountVerificationPage';
import { me as meSlice } from '../pages/AuthenticatedPage/authenticationSlice';
import ForgottenLoginPage from '../pages/AuthenticatedPage/ForgottenLoginPage';
import LoginRegisterPage from '../pages/AuthenticatedPage/LoginRegisterPage';
import ResetPasswordPage from '../pages/AuthenticatedPage/ResetPasswordPage';
import GeneralErrorPage from '../pages/AuthenticatedPage/GeneralErrorPage';
import HomePage from '../pages/HomePage';
import CreateChildAccount from '../pages/MyAccountPage/CreateChildAccount';
import EditChildAccount from '../pages/MyAccountPage/EditChildAccount';
import MyAccountPage from '../pages/MyAccountPage/MyAccount';
import MyApplicationsPage from '../pages/MyApplicationsPage';
import MyDraftsPage from '../pages/MyDraftsPage';
import NotFoundPage from '../pages/NotFoundPage';
import OnlineServicesPage from '../pages/OnlineServicesPage';
import EServicesPage from '../pages/OnlineServicesPage/components/EServicesPage';
import ETrademarksPage from '../pages/OnlineServicesPage/components/ETrademarksPage';
import EFillingsPage from '../pages/OnlineServicesPage/components/EFillingsPage';
import ChangesRegistrationPage from '../pages/OnlineServicesPage/components/ChangesRegistrationPage';
import RecordalsPage from '../pages/OnlineServicesPage/components/RecordalsPage';
import ObservationsPage from '../pages/OnlineServicesPage/components/ObservationsPage';
import ExtinctionRightsPage from '../pages/OnlineServicesPage/components/ExtinctionRightsPage';
import ModificationDecisionPage from '../pages/OnlineServicesPage/components/ModificationDecisionPage';
import OppositionPage from '../pages/OnlineServicesPage/components/OppositionPage';
import ProofOfRightsPage from '../pages/OnlineServicesPage/components/ProofOfRightsPage';
import ReplyProvisionalRefusalPage from '../pages/OnlineServicesPage/components/ReplyProvisionalRefusalPage';
import ReEstablishmentOfRightsPage from '../pages/OnlineServicesPage/components/ReEstablishmentOfRightsPage';
import SuspensionTimeChangesPage from '../pages/OnlineServicesPage/components/SuspensionTimeChangesPage';
import FeesRenewalPage from '../pages/OnlineServicesPage/components/FeesRenewalPage';
import ReplyNotificationsPage from '../pages/OnlineServicesPage/components/ReplyNotificationsPage';
import ProvisionalPatentPage from '../pages/OnlineServicesPage/components/ProvisionalPatentPage';
import SupplementaryProtectionPage from '../pages/OnlineServicesPage/components/SupplementaryProtectionPage';
import EuropeanPatentPage from '../pages/OnlineServicesPage/components/EuropeanPatentPage';
import InternationalPatentPage from '../pages/OnlineServicesPage/components/InternationalPatentPage';
import NationalUtilityPage from '../pages/OnlineServicesPage/components/NationalUtilityPage';
import AllTrademarkPage from '../pages/OnlineServicesPage/components/AllTrademarkPage';
import AllDesignPage from '../pages/OnlineServicesPage/components/AllDesignPage';
import AllPatentPage from '../pages/OnlineServicesPage/components/AllPatentPage';
import SSOLoginPage from '../pages/SSOPage/LoginPage';
import ImpersonateUserPage from '../pages/ImpersonateUserPage';
import { t } from '../providers';
import guards from './guards';

export const routes = [
    {
        path: '/',
        exact: true,
        component: HomePage,
        authGuard: true,
        getUpdateUserInfo: true,
        title: 'dashboard',
    },
    {
        path: ['/login', '/new-account'],
        exact: true,
        component: LoginRegisterPage,
    },
    {
        path: '/forgotten-login',
        exact: true,
        component: ForgottenLoginPage,
    },
    {
        path: '/login/oauth2/challenge',
        exact: true,
        component: SSOLoginPage,
    },
    {
        path: '/reset/token/:token',
        exact: true,
        component: ResetPasswordPage,
    },
    {
        path: ['/child/registration/token/:token', '/registration/token/:token', '/registration/verify'],
        exact: true,
        component: AccountVerificationPage,
    },
    {
        path: '/my-account/:tab',
        exact: true,
        authGuard: true,
        component: MyAccountPage,
        title: 'my.account',
    },
    {
        path: '/child-accounts/create',
        exact: true,
        authGuard: true,
        component: CreateChildAccount,
        canAccess: guards.canAccessCreateOrEditChildAccount,
    },
    {
        path: '/child-accounts/edit',
        exact: true,
        authGuard: true,
        component: EditChildAccount,
        canAccess: guards.canAccessCreateOrEditChildAccount,
    },
    {
        path: '/my-applications',
        exact: true,
        authGuard: true,
        component: MyApplicationsPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        title: 'my.applications',
    },
    {
        path: '/my-applications/:service',
        exact: true,
        authGuard: true,
        component: MyApplicationsPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        title: 'my.applications',
    },
    {
        path: '/impersonate-user',
        exact: true,
        authGuard: true,
        component: ImpersonateUserPage,
        canAccess: guards.canAccessImpersonateUsers,
    },
    // {
    //     path: '/my-drafts',
    //     exact: true,
    //     authGuard: true,
    //     component: MyDraftsPage,
    //     canAccess: guards.canAccessTrademarksOrDesigns,
    //     title: 'my.draft.applications',
    // },
    // {
    //     path: '/my-drafts/:service',
    //     exact: true,
    //     authGuard: true,
    //     component: MyDraftsPage,
    //     canAccess: guards.canAccessTrademarksOrDesigns,
    //     title: 'my.draft.applications',
    // },
    {
        path: '/online-services',
        exact: true,
        authGuard: true,
        component: OnlineServicesPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service',
        exact: true,
        authGuard: true,
        component: OnlineServicesPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/e-filling',
        exact: true,
        authGuard: true,
        component: EFillingsPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },

    {
        path: '/online-services/:service/e-services',
        exact: true,
        authGuard: true,
        component: EServicesPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/search',
        exact: true,
        authGuard: true,
        component: ETrademarksPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/trademark/all',
        exact: true,
        authGuard: true,
        component: AllTrademarkPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/trademark/favourites',
        exact: true,
        authGuard: true,
        component: AllTrademarkPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/design/all',
        exact: true,
        authGuard: true,
        component: AllDesignPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/design/favourites',
        exact: true,
        authGuard: true,
        component: AllDesignPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/patents/all',
        exact: true,
        authGuard: true,
        component: AllPatentPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/patents/favourites',
        exact: true,
        authGuard: true,
        component: AllPatentPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/changes-registration',
        exact: true,
        authGuard: true,
        component: ChangesRegistrationPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/recordals',
        exact: true,
        authGuard: true,
        component: RecordalsPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/observations',
        exact: true,
        authGuard: true,
        component: ObservationsPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/extinction-of-rights',
        exact: true,
        authGuard: true,
        component: ExtinctionRightsPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/modification-of-decision',
        exact: true,
        authGuard: true,
        component: ModificationDecisionPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/opposition',
        exact: true,
        authGuard: true,
        component: OppositionPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/proof-of-rights',
        exact: true,
        authGuard: true,
        component: ProofOfRightsPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/reply-provisional-refusal',
        exact: true,
        authGuard: true,
        component: ReplyProvisionalRefusalPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/reestablishment-of-rights',
        exact: true,
        authGuard: true,
        component: ReEstablishmentOfRightsPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/suspension-time-changes',
        exact: true,
        authGuard: true,
        component: SuspensionTimeChangesPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/fees-renewal-revalidation',
        exact: true,
        authGuard: true,
        component: FeesRenewalPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/reply-notifications',
        exact: true,
        authGuard: true,
        component: ReplyNotificationsPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/request-provisional-patent',
        exact: true,
        authGuard: true,
        component: ProvisionalPatentPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/request-supplementary-protection',
        exact: true,
        authGuard: true,
        component: SupplementaryProtectionPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/request-european-patent',
        exact: true,
        authGuard: true,
        component: EuropeanPatentPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/request-international-patent',
        exact: true,
        authGuard: true,
        component: InternationalPatentPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/online-services/:service/:category/request-national-utility-model',
        exact: true,
        authGuard: true,
        component: NationalUtilityPage,
        canAccess: guards.canAccessTrademarksOrDesigns,
        getUpdateUserInfo: true,
        title: 'online.services.title',
    },
    {
        path: '/error',
        exact: true,
        component: GeneralErrorPage,
    },
    {
        path: '*',
        component: NotFoundPage,
    },
];

const RouteWithSubRoutes = ({ component: Component, authGuard, canAccess, getUpdateUserInfo, title = '', ...rest }) => {
    const me = useSelector(meSlice);
    const { path } = rest;
    const isLoggedIn = !!me;
    const { userType, authorities } = me || {};

    const allowedComponent = guards.accessCheckRender(Component, userType, authorities, canAccess);

    const renderFunction = authGuard
        ? guards.AuthenticatedRender(allowedComponent, isLoggedIn, getUpdateUserInfo)
        : (props) => <Component {...props} />;

    const splittedUrl = window.location.href.split('/');
    const service = path.includes(':') ? splittedUrl[5] : null;
    const serviceLiteral = service
        ? service != 'patents' && service != 'child-accounts'
            ? service + 's'
            : service != 'child-accounts'
            ? service
            : null
        : null;

    document.title =
        title !== '' ? `${t(serviceLiteral)} ${serviceLiteral ? '-' : ''} ${t(title)} ${service ? '-' : ''} ${t('user.area')}` : `${t('user.area')}`;
    return <Route render={renderFunction} {...rest} />;
};

export const RenderRoutes = () => (
    <Switch>
        {routes.map((route, i) => (
            <RouteWithSubRoutes key={i} {...route} />
        ))}
    </Switch>
);
